export const ROUTES_PREFIX_V1 = "/api/v1";

export const ERROR_QUERY_PARAM_NAME = "error";